import Random from "../../../../src/mdx/api/endpoints/random.mdx";
import * as React from 'react';
export default {
  Random,
  React
};